import { createAction } from '@reduxjs/toolkit';

import { RoleChangedPayload } from '../../../pages/call/types';
import { MutePeerRecordingPayload } from './types';

export interface KickPeerPayload {
    peerId: string;
    withBan: boolean;
}

export const mutePeerAudio = createAction<string>('moderation/mutePeerAudio');
export const mutePeerVideo = createAction<string>('moderation/mutePeerVideo');
export const mutePeerScreenSharing = createAction<string>('moderation/mutePeerScreenSharing');
export const muteAllPeerAudio = createAction<string>('moderation/muteAllPeerAudio');
export const muteAllPeerVideo = createAction<string>('moderation/muteAllPeerVideo');
export const muteAllPeerScreenSharing = createAction<string>('moderation/muteAllPeerScreenSharing');
export const makeUserAnModerator = createAction<string>('moderation/makeUserAnModerator');
export const makeUserAnMember = createAction<string>('moderation/makeUserAnMember');
export const setConferenceAccessLevel = createAction<string>('moderation/setConferenceAccessLevel');
export const setBroadcastAccessLevel = createAction<string>('moderation/setBroadcastAccessLevel');
export const kickPeer = createAction<KickPeerPayload>('moderation/kickPeer');
export const closeRoom = createAction('moderation/closeRoom');
export const muteAllPeerReactions = createAction('moderation/muteAllPeerReactions');
export const mutePeerReaction = createAction<string>('moderation/mutePeerReactionSaga');
export const mutePeerRecording = createAction<MutePeerRecordingPayload>('moderation/mutePeerRecording');
export const muteAllRecordings = createAction<Maybe<boolean>>('moderation/muteAllRecordings');
// Команды от бэка
export const muteRecordingCommand = createAction<Maybe<boolean>>('moderation/muteRecordingCommand');
export const moderationRoleChanged = createAction<RoleChangedPayload>('moderation/moderationRoleChanged');
